import { useEffect } from "react";
import { Footer, PROBLEM_ADDRESS, PublicHeader, link } from "../App";
import { Doc } from "../Doc";
import { useLang, useT } from "../i18n";
import { LEGAL_PAGES, type LegalDocument, type LegalPageId } from "../legal";

/** Legal information is readable before sign-in and uses the same reading layout as the guide. */
export function LegalPage({ page }: { page: LegalPageId }) {
  const t = useT();
  const { lang } = useLang();
  const document: LegalDocument = t.legal.pages[page];
  useEffect(() => { if (!location.hash) window.scrollTo(0, 0); }, [page]);
  return (
    <>
      <PublicHeader />
      <Doc key={page}>
        <div lang={lang === "sr" ? "sr-Latn" : "en"} dir="ltr">
          <h1>{document.title}</h1>
          <p className="muted small">{t.legal.updated}</p>
          <p className="lead">{document.lead}</p>
          <section className="legal-summary">
            <h2>{t.legal.summaryTitle}</h2>
            <ul>{document.summary.map((item) => <li key={item}>{item}</li>)}</ul>
          </section>
          <nav className="legal-links small" aria-label={t.legal.navigation}>
            {LEGAL_PAGES.map((id) => (
              <a key={id} href={`/${id}`} onClick={link(`/${id}`)} aria-current={page === id ? "page" : undefined}>
                {t.footer[id]}
              </a>
            ))}
          </nav>
          {document.sections.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.links && <ul>{section.links.map(({ label, href }) => <li key={href}><a href={href}>{label}</a></li>)}</ul>}
            </section>
          ))}
          <p className="legal-contact">{t.legal.contact}{" "}<a href={`mailto:${PROBLEM_ADDRESS}`}>{PROBLEM_ADDRESS}</a>.</p>
        </div>
      </Doc>
      <Footer />
    </>
  );
}
